module.exports = __webpack_public_path__ + "static/img/aboutus_icon_mail (1).e5cc0ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/aboutUs/aboutus_icon_mail (1).png
// module id = 2t6f
// module chunks = 0